import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getUserDefinedFieldsListItems = createAsyncThunk(
  "userDefinedFields/getUserDefinedFieldsListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.userDefined.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getUserDefinedFieldDetailById = createAsyncThunk(
  "userDefinedFields/getUserDefinedFieldDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid  ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.userDefinedFields.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const userDefinedFieldsSlice = createSlice({
  name: "userDefinedFields",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserDefinedFieldsListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getUserDefinedFieldsListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getUserDefinedFieldsListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getUserDefinedFieldDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getUserDefinedFieldDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getUserDefinedFieldDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = userDefinedFieldsSlice.actions;
export default userDefinedFieldsSlice.reducer;
